/**
 * @deprecated Powered by CLS instead of ILS. Prefer ALTER_LIST_MEMBERSHIP.
 */
export const ACTION_TYPE = 'actionType';
/**
 * @deprecated Powered by CLS instead of ILS. Prefer ALTER_LIST_MEMBERSHIP.
 */
export const LIST_ID = 'listId';
/**
 * @deprecated Powered by CLS instead of ILS. Prefer ALTER_LIST_MEMBERSHIP.
 */
export const SHOULD_ADD = 'shouldAdd';